import {useWatch} from "react-hook-form";

export default function useUniqueOptionsWith(name, uniqueOptionsWith, choices) {
    const values = useWatch({
        name: uniqueOptionsWith?.split('|').filter(fieldName => fieldName !== name) ?? [],
        disabled: !uniqueOptionsWith,
    })?.filter(Boolean);

    if (!uniqueOptionsWith) {
        return {
            finalChoices: choices,
        }
    }

    // values might be string[] or array of string[]
    const usedValues = values.flat();
    const finalChoices = choices.filter(choice => !usedValues.includes(choice.value) || choice.value === '');

    return {
        finalChoices,
    }
}
